// import the required animation functions from the angular animations module
import { trigger, state, animate, transition, style, AnimationTriggerMetadata } from '@angular/animations';

export const titleTemplateAnimation =
trigger('titleTemplateAnimation', [
    transition(':enter', [
        style({ opacity: 0, position: 'relative', top: '-40px', 'transition-timing-function': 'ease-in' }),
        animate('0.3s', style({ opacity: 1, top: '0px' }))
    ])
]);
